import React, { useRef } from "react";
import "./PartnerStatusTitleContainer.scss";

import { useSearchParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";
import { MdLocalShipping, MdWarningAmber } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";

const PartnerStatusTitleContainer = ({ data, setActiveOrder }) => {
  const swiperRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (id) => {
    searchParams.set("orderId", id);
    setSearchParams(searchParams);
    setActiveOrder(data.find((item) => item.id === id));
  };

  return (
    <div id='PartnerStatusTitleContainer'>
      <h2>My shipments</h2>
      <div className='separator' />
      {data && data?.length > 0 && (
        <div className='swiperContainer'>
          <Swiper
            ref={swiperRef}
            spaceBetween={16}
            slidesPerView='auto'
            freeMode={true}
            modules={[FreeMode]}
          >
            {data?.map((item) => {
              const cargo = item?.cargos?.[0];
              return (
                <SwiperSlide key={item.id}>
                  <div
                    className={`content ${
                      item.id?.toString() === searchParams.get("orderId") ? "active" : ""
                    }`}
                    onClick={() => handleChange(item.id)}
                  >
                    <div className='icon'>
                      <MdLocalShipping />
                    </div>
                    <div className='infoContainer'>
                      <div className='topSide'>
                        <div className='route'>
                          {cargo?.locations?.[0]?.country || "GE"} →{" "}
                          {cargo?.locations?.[cargo?.locations?.length - 1]?.country || "ES"}
                        </div>
                        <div className='icon'>
                          {item?.todaySent ? (
                            <FaCheckCircle style={{ color: "#287D3C" }} />
                          ) : (
                            <MdWarningAmber color='#B95000' />
                          )}
                        </div>
                      </div>
                      <div className='trailerNumbers'>{item?.transports?.[0]?.number}</div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      )}
    </div>
  );
};

export default PartnerStatusTitleContainer;
